// extracted by mini-css-extract-plugin
export var closeBtn = "ThemeController-module--closeBtn--e62ed";
export var darkIcon = "ThemeController-module--darkIcon--be404";
export var lightIcon = "ThemeController-module--lightIcon--3b0a7";
export var toggleBtn = "ThemeController-module--toggleBtn--7bc60";
export var wrapper = "ThemeController-module--wrapper--4359c";